import type { IApiResponse } from 'v2/interfaces/api';

import apiService from './api';
import type { ApiService } from './api';

type Response<T> = IApiResponse<T>;

export class ApiServiceProxy {
  constructor(private apiService: ApiService) {}

  public get<T = any>(url: string, params?: any, headers?: any, oldAgent = false): Promise<Response<T>> {
    return this.apiService.get(url, params, headers, oldAgent).toPromise();
  }

  public post<T = any>(url: string, body: any, headers?: any, oldAgent = false): Promise<Response<T>> {
    return this.apiService.post(url, body, headers, oldAgent).toPromise();
  }

  public put<T = any>(url: string, body: any, headers?: any, oldAgent = false): Promise<Response<T>> {
    return this.apiService.put(url, body, headers, oldAgent).toPromise();
  }

  public delete<T = any>(url: string, params?: any, headers?: any, oldAgent = false): Promise<Response<T>> {
    return this.apiService.delete(url, params, headers, oldAgent).toPromise();
  }

  public upload<T = any>(url: string, data: FormData): Promise<Response<T>> {
    return this.apiService.post('POST', url, data).toPromise();
  }
}

export const apiServiceProxy = new ApiServiceProxy(apiService);
